import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getActivities = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Activity/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching activities:", error);
    throw error;
  }
};

export const saveActivity = async (activity) => {
  const response = await axios.post(`${BASE_URL}/api/Activity/save`, activity, {
    headers: getAuthHeader(),
  });
  return response.data;
}; 